/* Halloway / Clarity — product-gallery CRO tracking v1, 07 Oct 2026.
   Counts real gallery index changes, modal zooms, image views and visible dwell.
   Does not collect emails, customer identities or click-tracking tokens.
*/
(function () {
  'use strict';
  if (window.__hwClarityPhotoTrackingV1) return;
  window.__hwClarityPhotoTrackingV1 = true;

  var VERSION = 'hw-gallery-2026-10-07-v1';
  var product = (location.pathname.match(/^\/products\/([^\/?#]+)/) || [])[1] || '';
  var pending = [];
  var initSeen = new WeakSet();
  var countCache = Object.create(null);

  function allowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return !!cp.analyticsProcessingAllowed();
      }
    } catch (_) {}
    return true;
  }

  function clean(value, max) {
    return String(value == null ? '' : value)
      .replace(/[\u0000-\u001f<>]/g, ' ')
      .trim()
      .slice(0, max || 110);
  }

  function send(args) {
    if (!allowed()) return;
    if (typeof window.clarity === 'function') {
      try { window.clarity.apply(window, args); } catch (_) {}
    } else if (pending.length < 250) {
      pending.push(args);
    }
  }
  function flush() {
    if (!allowed() || typeof window.clarity !== 'function') return;
    while (pending.length) {
      try { window.clarity.apply(window, pending.shift()); } catch (_) {}
    }
  }
  function tag(name, value) { if (value !== null && value !== undefined && value !== '') send(['set', name, clean(value)]); }
  function event(name) { send(['event', name]); }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  var flushing = setInterval(function () {
    flush();
    if (typeof window.clarity === 'function') clearInterval(flushing);
  }, 400);
  setTimeout(function () { clearInterval(flushing); flush(); }, 12000);

  function getStore(key) {
    try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
  }
  function putStore(key, val) {
    if (!allowed()) return;
    try { window.sessionStorage.setItem(key, String(val)); } catch (_) {}
  }
  function totalCount(name) {
    var key = 'hw.clarity.' + name;
    if (!(name in countCache)) countCache[name] = Number(getStore(key) || 0) || 0;
    countCache[name] += 1;
    putStore(key, countCache[name]);
    return countCache[name];
  }

  function domainFrom(ref) {
    try { return new URL(ref).hostname.replace(/^www\./, '').toLowerCase(); } catch (_) { return ''; }
  }
  function channelFrom(host, utm) {
    if (/instagram\.com$/.test(host)) return 'instagram';
    if (/facebook\.com$/.test(host) || host === 'fb.com') return 'facebook';
    if (/google\./.test(host)) return 'google';
    if (/bing\.com$/.test(host)) return 'bing';
    if (/instagram/i.test(utm)) return 'instagram_utm';
    if (/facebook|(^|[^a-z])fb([^a-z]|$)/i.test(utm)) return 'facebook_utm';
    if (/google/i.test(utm)) return 'google_utm';
    if (utm) return 'other_utm';
    if (!host) return 'direct_unknown';
    return 'other_referral';
  }
  function acquireOrigin() {
    if (!allowed()) return null;
    var saved = getStore('hw.clarity.origin.v1');
    if (saved) {
      try { return JSON.parse(saved); } catch (_) {}
    }
    var p = new URLSearchParams(location.search);
    var host = domainFrom(document.referrer);
    var own = location.hostname.replace(/^www\./, '').toLowerCase();
    if (host === own) host = '';
    var utm = clean(p.get('utm_source'), 80);
    var origin = {
      channel: channelFrom(host, utm),
      referrer: host || 'none',
      utm_source: utm || 'none',
      utm_medium: clean(p.get('utm_medium'), 80) || 'none',
      utm_campaign: clean(p.get('utm_campaign'), 100) || 'none',
      utm_content: clean(p.get('utm_content'), 100) || 'none',
      campaign_id: clean(p.get('campaign_id') || p.get('utm_id'), 80) || 'none',
      ad_id: clean(p.get('ad_id'), 80) || 'none',
      click_provider: p.has('fbclid') ? 'meta' : (p.has('gclid') ? 'google' : 'none'),
      landing_page: clean(location.pathname, 95)
    };
    putStore('hw.clarity.origin.v1', JSON.stringify(origin));
    return origin;
  }
  function attributionTags() {
    if (!allowed()) return;
    var origin = acquireOrigin();
    if (!origin) return;
    tag('hw_tracking_version', VERSION);
    tag('hw_origin_channel', origin.channel);
    tag('hw_origin_referrer_domain', origin.referrer);
    tag('hw_origin_utm_source', origin.utm_source);
    tag('hw_origin_utm_medium', origin.utm_medium);
    tag('hw_origin_utm_campaign', origin.utm_campaign);
    tag('hw_origin_utm_content', origin.utm_content);
    tag('hw_origin_campaign_id', origin.campaign_id);
    tag('hw_origin_ad_id', origin.ad_id);
    tag('hw_origin_click_provider', origin.click_provider);
    tag('hw_origin_landing_page', origin.landing_page);
    tag('hw_device', matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop');
    tag('hw_product', product || 'other_page');
  }

  attributionTags();
  document.addEventListener('visitorConsentCollected', attributionTags);
  window.addEventListener('load', attributionTags, { once: true });

  function instrument(root, scrollTrack, slides, zoomDialog, kind, calculateIndex) {
    if (!root || !scrollTrack || !slides.length || initSeen.has(root)) return;
    initSeen.add(root);

    var productKey = product || 'other';
    var state = {
      index: Math.max(0, Math.min(slides.length - 1, calculateIndex())),
      visible: false,
      start: 0,
      viewTimer: 0,
      viewCounted: false,
      lastAction: null,
      scrollTimer: 0,
      pinchActive: false,
      uniqueViews: new Set()
    };
    var galleryObs = null;
    var zoomObs = null;

    function photo(idx) {
      var slide = slides[idx];
      var img = slide && slide.querySelector('img');
      var id = slide && slide.dataset && slide.dataset.imageId;
      var filename = '';
      if (img) {
        try { filename = (new URL(img.currentSrc || img.src)).pathname.split('/').pop(); } catch (_) {}
      }
      return { id: id || filename || ('position_' + (idx + 1)), filename: filename };
    }

    function interaction(name, idx, method, seconds) {
      if (!allowed()) return;
      var position = idx + 1;
      var key = pad(position);
      var counter = totalCount(name);
      tag('hw_product', productKey);
      tag('hw_gallery_kind', kind);
      tag('hw_gallery_last_action', name);
      tag('hw_gallery_last_method', method || 'unknown');
      tag('hw_gallery_last_image', position);
      tag('hw_gallery_last_image_id', photo(idx).id);
      tag('hw_' + name + '_count', counter);
      if (seconds != null) tag('hw_gallery_last_dwell_seconds', seconds);
      event(name);
      // The indexed event makes the exact photo observable in Clarity event filters.
      event(name + '_p' + key);
    }

    function seen(idx) {
      state.uniqueViews.add(idx);
      var pos = pad(idx + 1);
      var key = 'hw.clarity.' + productKey + '.p' + pos + '.views';
      var n = (Number(getStore(key) || 0) || 0) + 1;
      putStore(key, n);
      tag('hw_photo_p' + pos + '_views', n);
      tag('hw_gallery_unique_photos', state.uniqueViews.size);
      interaction('gallery_image_view', idx, 'visible_700ms');
    }

    function stop() {
      clearTimeout(state.viewTimer);
      state.viewTimer = 0;
      if (state.start) {
        var elapsed = Math.max(0, performance.now() - state.start);
        var idx = state.index;
        state.start = 0;
        if (state.viewCounted && elapsed >= 1000) {
          var sec = Math.max(1, Math.round(elapsed / 1000));
          var pos = pad(idx + 1);
          var storageKey = 'hw.clarity.' + productKey + '.p' + pos + '.seconds';
          var cumulative = (Number(getStore(storageKey) || 0) || 0) + sec;
          putStore(storageKey, cumulative);
          tag('hw_photo_p' + pos + '_dwell_seconds', cumulative);
          interaction('gallery_image_dwell', idx, 'visible_time', sec);
        }
      }
      state.viewCounted = false;
    }

    function start() {
      if (!state.visible || document.hidden || state.start) return;
      state.start = performance.now();
      state.viewCounted = false;
      var idx = state.index;
      state.viewTimer = setTimeout(function () {
        state.viewTimer = 0;
        if (state.visible && !document.hidden && state.start && state.index === idx) {
          state.viewCounted = true;
          seen(idx);
        }
      }, 700);
    }

    function noteAction(method) { state.lastAction = { method: method, when: Date.now() }; }

    function updateActive() {
      if (!root.isConnected) return;
      var next = Math.max(0, Math.min(slides.length - 1, calculateIndex()));
      if (next === state.index) return;
      stop();
      state.index = next;
      var recent = state.lastAction && Date.now() - state.lastAction.when < 2800;
      // Only count user-driven image changes as gallery_swipe.
      if (recent) interaction('gallery_swipe', next, state.lastAction.method);
      state.lastAction = null;
      start();
    }

    root.addEventListener('click', function (e) {
      var target = e.target instanceof Element ? e.target : null;
      if (!target) return;
      if (target.closest('[data-hw-thumb]')) noteAction('thumbnail');
      else if (target.closest('[data-hw-next],[data-hw-previous]')) noteAction('arrow');
      else if (scrollTrack.contains(target)) {
        if (!state.lastAction || state.lastAction.method !== 'touch' ||
            Date.now() - state.lastAction.when > 850) noteAction('image_click');
      } else if (kind === 'native' && target.closest('slideshow-controls,slideshow-arrows')) {
        noteAction('native_control');
      }
    }, true);

    scrollTrack.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') noteAction('touch');
      else if (e.pointerType === 'pen') noteAction('pen');
      else noteAction('mouse');
    }, { passive: true });
    scrollTrack.addEventListener('wheel', function () { noteAction('wheel'); }, { passive: true });
    scrollTrack.addEventListener('keydown', function (e) {
      if (/^Arrow(Left|Right)$/.test(e.key)) noteAction('keyboard');
    }, true);
    scrollTrack.addEventListener('scroll', function () {
      clearTimeout(state.scrollTimer);
      state.scrollTimer = setTimeout(updateActive, 180);
    }, { passive: true });

    if (typeof IntersectionObserver === 'function') {
      galleryObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== root) return;
          var v = entry.intersectionRatio >= 0.18;
          if (v === state.visible) return;
          state.visible = v;
          if (v) {
            updateActive();
            start();
          } else stop();
        });
      }, { threshold: [0, 0.18, 0.3, 0.6] });
      galleryObs.observe(root);
    } else { state.visible = true; start(); }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else { updateActive(); start(); }
    });
    window.addEventListener('pagehide', stop);

    if (zoomDialog && typeof MutationObserver === 'function') {
      var wasOpen = zoomDialog.hasAttribute('open');
      zoomObs = new MutationObserver(function () {
        var opened = zoomDialog.hasAttribute('open');
        if (opened && !wasOpen) interaction('gallery_zoom', state.index, 'modal_open');
        wasOpen = opened;
      });
      zoomObs.observe(zoomDialog, { attributes: true, attributeFilter: ['open'] });
    }

    // Optional separate signal: browser pinch zoom (not always exposed by iOS).
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        if (!state.visible) return;
        var scale = Number(window.visualViewport.scale || 1);
        if (scale >= 1.15 && !state.pinchActive) {
          state.pinchActive = true;
          interaction('gallery_pinch_zoom', state.index, 'visual_viewport');
        } else if (scale < 1.05) {
          state.pinchActive = false;
        }
      }, { passive: true });
    }

    root.addEventListener('shopify:section:unload', function () {
      stop();
      clearTimeout(state.scrollTimer);
      if (galleryObs) galleryObs.disconnect();
      if (zoomObs) zoomObs.disconnect();
    }, { once: true });
  }

  function initCustomGalleries(container) {
    (container || document).querySelectorAll('.hw-gallery').forEach(function (root) {
      var track = root.querySelector('[data-hw-gallery]');
      var slides = track ? Array.from(track.querySelectorAll('[data-hw-slide]')) : [];
      var owner = root.closest('[data-hw-case],[data-hw-winder],[data-hw-belgrave]') || root.parentElement;
      var dialog = owner && owner.querySelector('[data-hw-dialog]');
      if (!track || !slides.length) return;
      instrument(root, track, slides, dialog, 'halloway', function () {
        return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      });
    });
  }

  function initStandardGalleries(container) {
    (container || document).querySelectorAll('media-gallery').forEach(function (root) {
      var slideshow = root.querySelector('slideshow-component');
      var track = slideshow && (slideshow.querySelector('[ref="scroller"]') || slideshow.querySelector('.slideshow__scroller'));
      var slides = track ? Array.from(track.querySelectorAll('slideshow-slide')) : [];
      var dialog = root.querySelector('zoom-dialog dialog');
      if (!track || !slides.length) return;
      instrument(root, track, slides, dialog, 'shopify', function () {
        var bound = track.getBoundingClientRect();
        var closest = 0;
        var distance = Infinity;
        slides.forEach(function (slide, i) {
          var diff = Math.abs(slide.getBoundingClientRect().left - bound.left);
          if (diff < distance) { distance = diff; closest = i; }
        });
        return closest;
      });
    });
  }

  function init(container) {
    initCustomGalleries(container);
    initStandardGalleries(container);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();